export const PATHS = {
  home: '/',
  sluzby: '/sluzby',
  cennik: '/cennik',
  omne: '/o-mne',
  kontakt: '/kontakt',
  projekty: '/projekty',
  ochranaOsobnychUdajov: '/ochrana-osobnych-udajov',
  cookies: '/cookies',
  pravneInformacie: '/pravne-informacie',
  podmienkyPouzivania: '/podmienky-pouzivania',
  homeSluzby: '/#sluzby',
} as const;
